import React from 'react';
import styled from '@emotion/styled';
import { IAirport } from '@move-frontend/dap';
import Responsive from '../../../../../ui/utils/Responsive';
import { StatusLabel } from '../../../shared/status/ui';
import { withTranslate } from '../../../../shared/i18n/translate';
import { IFlightPublicStatus } from '../../../shared/status/domain/models/IFlightPublicStatus';

const StyledStatusRow = styled.div`
	flex: 1;
	flex-wrap: wrap;
	display: flex;
	padding-left: 20px;
	padding-right: 20px;
	padding-top: 10px;
	padding-bottom: 10px;
`;

const ArrivalHeading = styled.h3`
	min-width: 65%;
	flex: 1 0 65%;

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		font-size: 26px;
	}

	@media (${Responsive.getMediaQueryForBreakpoint('mobile')}) {
		font-size: 24px;
	}
`;

const StatusLabelWrap = styled.div`
	min-width: 35%;
	flex: 1 0 35%;
	text-align: right;
	align-items: flex-end;
	display: flex;
	justify-content: flex-end;
	margin-bottom: 16px;
`;

interface IProps {
	status: IFlightPublicStatus;
	arrival: boolean;
	iata: string;
	airport?: IAirport;
}

export const StatusRow = withTranslate<IProps>(
	({ t, arrival, status, iata, airport }) => {
		const arrivalTranslationKey = arrival
			? 'flight_details_arrival_from'
			: 'flight_details_departure_to';
		const destination =
			airport && airport.city ? `${airport.city} (${iata})` : iata;

		return (
			<StyledStatusRow>
				<ArrivalHeading>
					{`${t(arrivalTranslationKey)} ${destination}`}
				</ArrivalHeading>

				<StatusLabelWrap>
					<StatusLabel status={status} />
				</StatusLabelWrap>
			</StyledStatusRow>
		);
	},
);
